/* eslint-disable */

// export const twillBase = (window.location.hostname === 'localhost') ? 'https://mktax-twill.ddev.site' : 'https://www.marketaxess.com/twli';
export const twillBase = 'https://www.marketaxess.com/twli';


class API {

    /**
     * Base URL for API (no trailing slashes, this is used to prefix <img> tags as well).
     *
     * @type {string}
     */
    static homePageId = '3311';

  	static getHost(type = 'gql') {

  		const currentHost = window.location.hostname;

        // Switch endpoint for staging
        //if (currentHost === 'frontend.stage.marketaxess.our-service-galaxy.xyz') {
        //      return 'https://content.stage.marketaxess.our-service-galaxy.xyz'
        //}

        if ((type == 'gql') && (window.mktgqlh)) {
            return window.mktgqlh;
        }

        if ((type == 'data') && (window.mktdatah)) {
            return window.mktdatah;
        }


        return `https://${currentHost}`;
  	}

  	static getFallbackHost() {
          return this.getHost();
	}
}

export default API;



// WEBPACK FOOTER //
// ./frontend/config/API.js